import { render } from "./InsertImage.vue?vue&type=template&id=7db2ebb7&scoped=true"
import script from "./InsertImage.vue?vue&type=script&lang=js"
export * from "./InsertImage.vue?vue&type=script&lang=js"

import "./InsertImage.vue?vue&type=style&index=0&id=7db2ebb7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db2ebb7"]])

export default __exports__